import { Box, Button, FormControl, FormHelperText, InputLabel, OutlinedInput, Stack, TextField, Typography, } from '@mui/material'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { FunctionComponent } from 'react';
import { IProductComponent } from '../../../shared/services/product-component/product-component.model';
import { IContactSupplierDetails } from '../../../shared/services/contact-supplier/contact-supplier.model';
import { Link } from 'react-router-dom';
import { SupplierPicker } from '../form-field-components/supplier-picker';

export const ProductComponentForm: FunctionComponent<{
  productComponent?: IProductComponent,
  isEditPage: boolean,
  constactSuppliers: IContactSupplierDetails[],
  onSubmit: (values: IProductComponent) => void
}> = ({
  productComponent,
  constactSuppliers,
  isEditPage = false,
  onSubmit
}) => {

    const productComponentSchema = Yup.object().shape({
      name: Yup.string().required('Please give this product a name'),
      description: Yup.string().nullable(),
      componentConfiguration: Yup.string().nullable(),
      kgCarbonEmission: Yup.number().nullable(),
      contactSupplierId: Yup.string().nullable()
    })

    const formik = useFormik<IProductComponent>({
      initialValues: {
        name: productComponent?.name,
        description: productComponent?.description,
        componentConfiguration: productComponent?.componentConfiguration,
        kgCarbonEmission: productComponent?.kgCarbonEmission,
        contactSupplierId: productComponent?.contactSupplierId
      },
      validationSchema: productComponentSchema,
      onSubmit: (values) => {
        onSubmit(values)
      }
    })

    const updateHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
      formik.setFieldValue(e.target.name, e.target.value)
    }

    return (
      <Box component='form'>
        <Stack display='flex' flexDirection='column'>
          <Typography variant='h6' sx={{ mb: 2 }}>{isEditPage ? 'Edit Product Component' : 'Create New Product Component'}</Typography>
          <Stack sx={{ mb: 2 }}>
            <FormControl disabled>
              <TextField
                label='Component name'
                onChange={updateHandler}
                name='name'
                sx={{ color: 'text.secondary' }}
                error={formik.touched.name && Boolean(formik.errors.name)}
                value={formik.values.name || ''} />
            </FormControl>
            {formik.touched.name && formik.errors.name &&
              <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>
                {formik.errors.name ? <div>{formik.errors.name as string}</div> : null}
              </FormHelperText>
            }
          </Stack>

          <FormControl disabled sx={{ mb: 2 }}>
            <TextField
              label='Description'
              onChange={updateHandler}
              name='description'
              sx={{ color: 'text.secondary' }}
              value={formik.values.description || ''} />
          </FormControl>

          <FormControl disabled sx={{ mb: 2 }}>
            <TextField
              label='Configuration details'
              onChange={updateHandler}
              name='componentConfiguration'
              sx={{ color: 'text.secondary' }}
              value={formik.values.componentConfiguration || ''} />
          </FormControl>

          <FormControl sx={{ mb: 2 }}>
            <InputLabel>Product emissions
            </InputLabel>
            <OutlinedInput
              onChange={formik.handleChange}
              label='Product emissions'
              name='kgCarbonEmission'
              sx={{ color: 'text.secondary' }}
              value={formik.values.kgCarbonEmission || ''}
              type='number'
              inputProps={{ min: 0, step: 0.01 }} />
          </FormControl>

          <FormControl fullWidth>
            <SupplierPicker
              id="contactSupplierId"
              suppliers={constactSuppliers}
              label="Supplier (Optional)"
              value={formik.values.contactSupplierId}
              onChange={(id) => {
                formik.setFieldValue('contactSupplierId', id);
              }}
              disabled={constactSuppliers.length === 0}
            />
          </FormControl>

          <Stack sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', mt: 2 }}>
            <Box sx={{ mr: 2 }}>
              <Button variant='text' component={Link} to={!isEditPage ? '/products?tab=1' : `/products/component/${productComponent?.id}`}>
                <Typography sx={{ color: 'primary.main' }}>Cancel </Typography></Button>
            </Box>
            <Button onClick={() => formik.submitForm()}><Typography>Save</Typography></Button>
          </Stack>

        </Stack>
      </Box >
    )
  }